import { Component, Input, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';

@Component({
    selector: 'my-app-customizer',
    styles: [],
    template: require('./customizer.component.html'),
})

export class AppCustomizerComponent implements OnInit {
    public AppConfig: any;

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/customizer/customizer.component.ts